import React from 'react'
import { DialogTitle, Box, Typography } from '@mui/material'
import { StyledDialogContent } from '../../../../ui/dialogs'

import { ChangePwdFormComponent } from './change-pwd-form.component'

export const ChangePwdDialogComponent = ({ close }) => (
  <Box p={4}>
    <DialogTitle>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography variant="h4" color="primary">
          Información personal
        </Typography>
      </Box>
    </DialogTitle>
    <StyledDialogContent>
      <ChangePwdFormComponent {...{ close }} />
    </StyledDialogContent>
    {/* <DialogActions>
      <Button onClick={close}>Cerrar</Button>
    </DialogActions> */}
  </Box>
)
